// import React from "react";
// import { connect } from "react-redux";
// import { notifyGeneralInfo } from "../../actions";
// import axios from "axios";
// import { withRouter } from "react-router-dom/cjs/react-router-dom";
// const token = localStorage.getItem('authToken');
// class AddVratSubCategory extends React.Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             textInput: "",
//             userName: "",
//             title: "",
//             category: "",
//             areaInput: "",
//             categoryData: [],
//             city: "",
//             date: '',
//             isDateValid: true,
//             submissionStatus: null,
//             currentImageUrl: null,
//             submeet: false,
//             errors: [],
//             maxSize: 5 * 1024 * 1024, // 5MB in bytes
//         };
//     }

//     async componentDidMount() {
//         this.fetchData()
//     }

//     fetchData = async () => {
//         try {
//             const response = await axios.get(`https://samaj.aasmo.in/api/admin/vratcategory`,{
              
//         headers: {
//           Authorization: `Bearer ${token}`, 
//         }
//             });
//             if (response.data) {
//                 this.setState({ categoryData: response.data.categories });
//             }
//         } catch (error) {
//             console.error("Error fetching data:", error);
//         }
//     };



//     handleChange = (e) => {
//         const files = Array.from(e.target.files);
//         const errors = [];

//         files.forEach((file) => {
//             if (file.size > this.state.maxSize) {
//                 errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
//             } else {
//                 this.setState({
//                     textInput: file,
//                     currentImageUrl: URL.createObjectURL(file),
//                 });
//             }
//         });

//         this.setState({ errors });
//     };

//     handleSubmit = async (e) => {
//         e.preventDefault();

//         this.setState({ submeet: true });

//         const { textInput,userName, city, date, title, areaInput, category } = this.state;

//         // if (!textInput || !userName || !title || !areaInput || !category) {
//         //   return;
//         // }

//         try {

//             const formData = new FormData();
//             formData.append('image', textInput);
//             formData.append('name', userName);
       
//             formData.append('category', category);

//             const config = {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
                    

//           Authorization: `Bearer ${token}`, 
      
//                 }
//             };
//             console.log("1");

//             const response = await axios.post("https://samaj.aasmo.in/api/admin/vratsubcategory", formData, config);

//             if (response.status === 201) {
//                 console.log("2");
//                 this.setState({ submissionStatus: 'success', submeet: false });
//                 setTimeout(() => {
//                   this.props.history.push("/vratAurTyoharsubcategory");
//                 }, 2000);
//             }
//         } catch (error) {
//             console.log(error);
//             this.setState({ submissionStatus: 'error' });
//         }
//     };

//     render() {
//         const { textInput, isDateValid, date, title, currentImageUrl, city, userName, category, categoryData, submeet, areaInput, submissionStatus } = this.state;
//         const isNameValid = userName.trim().length > 0;
//         const isTitleValid = title.trim().length > 0;
//         const isCityValid = city?.trim().length > 0;

//     return (
//       <div className="col-md-12">
//         <div className="card">
//           <div className="header">
//             <h2>Add Vrat Aur Tyohar Sub Category</h2>
//           </div>
//           <div className="body">

//             <form onSubmit={this.handleSubmit}>

//             <div className="form-group">
//                                 <label htmlFor="bloodGroup">Category</label>
//                                 <select
//                                     className={`form-control ${submeet && !category && "parsley-error"
//                                         }`}
//                                     value={category}
//                                     name="category"
//                                     required=""
//                                     onChange={(e) => {
//                                         this.setState({ category: e.target.value });
//                                     }}
//                                 >
//                                     <option value="">Select Category</option>
//                                     {categoryData && categoryData.map((key) => (
//                                         <option key={key.id} value={key.id}>{key.name}</option>
//                                     ))}
//                                 </select>
//                                 {submeet && !category ? (
//                                     <ul className="parsley-errors-list filled" id="parsley-id-29">
//                                         <li className="parsley-required">Category is required.</li>
//                                     </ul>
//                                 ) : null}
//                             </div>

//             <div className="form-group">
//                 <label>Category Image</label>
//                 {      console.log(currentImageUrl)}
//                 {currentImageUrl && (
//                   <div>
//                     <img src={currentImageUrl} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
//                   </div>
//                 )}
//                 <input
//                   type="file"
//                   className={`form-control ${!textInput && submeet && "parsley-error"}`}
//                   name="textInput"
//                   required=""
//                   onChange={this.handleChange}
//                 />
//                 {!textInput && submeet ? (
//                   <ul className="parsley-errors-list filled">
//                     <li className="parsley-required">This value is required.</li>
//                   </ul>
//                 ) : null}
//               </div>

//               <div className="form-group">
//                 <label>Category Name</label>
//                 <input
//                   className={`form-control ${!isNameValid && submeet && "parsley-error"}`}
//                   value={userName}
//                   name="userName"
//                   required=""
//                   type="text"
//                   onChange={(e) => {
//                     this.setState({ userName: e.target.value });
//                   }}
//                 />
//                 {!isNameValid && submeet ? (
//                   <ul className="parsley-errors-list filled">
//                     <li className="parsley-required">
//                       This value is required.
//                     </li>
//                   </ul>
//                 ) : null}
//               </div>

//               {submissionStatus === 'success' && (
//                 <div className="alert alert-success" role="alert">
//                   Form submitted successfully!
//                 </div>
//               )}

//               <button className="btn btn-primary" type="submit">
//                 Submit
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// const mapStateToProps = ({ mailInboxReducer }) => ({});

// export default withRouter (connect(mapStateToProps, { notifyGeneralInfo })(AddVratSubCategory));


import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
const token = localStorage.getItem('authToken');

class AddVratSubCategory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            textInput: "",
            userName: "",
            category: "",
            categoryData: [],
            submissionStatus: null,
            currentImageUrl: null,
            submeet: false,
            errors: [],
            serverError: "", // For backend errors
            maxSize: 5 * 1024 * 1024,
        };
    }

    async componentDidMount() {
        this.fetchData()
    }

    fetchData = async () => {
        try {
            const response = await axios.get(`https://samaj.aasmo.in/api/admin/vratcategory`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data && response.data.categories) {
                this.setState({ categoryData: response.data.categories });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    handleChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.size > this.state.maxSize) {
            this.setState({ errors: [`${file.name} is too large, please select a file smaller than 5MB.`] });
            return;
        }

        this.setState({
            textInput: file,
            currentImageUrl: URL.createObjectURL(file),
            errors: []
        });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ submeet: true, serverError: "" });

        const { textInput, userName, category } = this.state;

        if (!textInput || !userName || !category) {
            return;
        }

        try {
            const formData = new FormData();
            formData.append('image', textInput);
            formData.append('name', userName);
            formData.append('category', category);

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`,
                }
            };

            const response = await axios.post("https://samaj.aasmo.in/api/admin/vratsubcategory", formData, config);

            if (response.status === 201) {
                this.setState({ submissionStatus: 'success', submeet: false });
                setTimeout(() => {
                    this.props.history.push("/vratAurTyoharsubcategory");
                }, 2000);
            }
        } catch (error) {
            console.log(error);
            if (error.response && error.response.data && error.response.data.error.includes("duplicate key")) {
                this.setState({
                    submissionStatus: 'error',
                    serverError: `Sub-category with name "${userName}" already exists. Please use a different name.`
                });
            } else {
                this.setState({
                    submissionStatus: 'error',
                    serverError: 'An unexpected error occurred. Please try again.'
                });
            }
        }
    };

    render() {
        const { textInput, currentImageUrl, userName, category, categoryData, submeet, submissionStatus, serverError, errors } = this.state;
        const isNameValid = userName.trim().length > 0;

        return (
            <div className="col-md-12">
                <div className="card">
                    <div className="header">
                        <h2>Add Vrat Aur Tyohar Sub Category</h2>
                    </div>
                    <div className="body">
                        <form onSubmit={this.handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="category">Category</label>
                                <select
                                    className={`form-control ${submeet && !category && "parsley-error"}`}
                                    value={category}
                                    name="category"
                                    required
                                    onChange={(e) => this.setState({ category: e.target.value })}
                                >
                                    <option value="">Select Category</option>
                                    {categoryData && categoryData.map((key) => (
                                        <option key={key.id} value={key.id}>{key.name}</option>
                                    ))}
                                </select>
                                {submeet && !category && <ul className="parsley-errors-list filled"><li className="parsley-required">Category is required.</li></ul>}
                            </div>

                            <div className="form-group">
                                <label>Sub Category Image</label>
                                {currentImageUrl && (
                                    <div>
                                        <img src={currentImageUrl} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
                                    </div>
                                )}
                                <input
                                    type="file"
                                    className={`form-control ${!textInput && submeet && "parsley-error"}`}
                                    name="textInput"
                                    required
                                    onChange={this.handleChange}
                                />
                                {!textInput && submeet && <ul className="parsley-errors-list filled"><li className="parsley-required">This value is required.</li></ul>}
                                {errors.length > 0 && <ul className="parsley-errors-list filled">{errors.map((err, i) => <li key={i}>{err}</li>)}</ul>}
                            </div>

                            <div className="form-group">
                                <label>Sub Category Name</label>
                                <input
                                    className={`form-control ${!isNameValid && submeet && "parsley-error"}`}
                                    value={userName}
                                    name="userName"
                                    required
                                    type="text"
                                    onChange={(e) => this.setState({ userName: e.target.value })}
                                />
                                {!isNameValid && submeet && <ul className="parsley-errors-list filled"><li className="parsley-required">This value is required.</li></ul>}
                            </div>

                            {submissionStatus === 'success' && <div className="alert alert-success" role="alert">Form submitted successfully!</div>}
                            {submissionStatus === 'error' && serverError && <div className="alert alert-danger" role="alert">{serverError}</div>}

                            <button className="btn btn-primary" type="submit">
                                Submit
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter(connect(mapStateToProps, { notifyGeneralInfo })(AddVratSubCategory));